/* eslint jsx-a11y/anchor-is-valid: 0 */

import React, {useState, useEffect, useRef} from "react";
import { useSearchParams } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  ButtonGroup,
  FormSelect,
  FormInput,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "shards-react";
import { accessCheck } from "../../utils/tools";
import moment from 'moment-timezone'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faSearch, faTimes, faFileInvoiceDollar, faArrowDown, faArrowUp, faFile, faCaretDown, faColumns, faCheck } from '@fortawesome/free-solid-svg-icons';
import Select from "react-select";
import DatePicker from "react-datepicker";

import DownloadButton from "../../components/common/DownloadButton";
import PageTitle from "../../components/common/PageTitle";
import Pagination from "../../components/common/Pagination";
import ActivityIndicator from "../../components/common/ActivityIndicator";
import EnhancedDateRangePicker from "../../components/common/EnhancedDateRangePicker";
import { startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfDay, endOfDay, sub } from "date-fns";
import generatePDF, { Resolution, Margin } from 'react-to-pdf';

import "react-datepicker/dist/react-datepicker.css";
import RowActions from '../../components/common/RowActions';

// We're now using EnhancedDateRangePicker, which includes its own styles
/* const datePickerStyles = `
  .react-datepicker {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    border-radius: 6px;
    border: 1px solid #eaedf3;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
  }
  
  .react-datepicker__header {
    background-color: #fff;
    border-bottom: 1px solid #eaedf3;
    padding-top: 10px;
  }
  
  .react-datepicker__current-month {
    color: #495057;
    font-weight: 600;
    margin-bottom: 8px;
  }
  
  .react-datepicker__day-name {
    color: #818ea3;
    font-size: 12px;
    margin: 3px;
  }
  
  .react-datepicker__day {
    color: #495057;
    margin: 3px;
    border-radius: 4px;
  }
  
  .react-datepicker__day:hover {
    background-color: rgba(33, 170, 115, 0.05);
  }
  
  .react-datepicker__day--selected,
  .react-datepicker__day--in-range,
  .react-datepicker__day--in-selecting-range {
    background-color: rgba(33, 170, 115, 0.8);
    color: white;
  }
  
  .react-datepicker__day--keyboard-selected {
    background-color: rgba(33, 170, 115, 0.5);
    color: white;
  }
  
  .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
    background-color: rgba(33, 170, 115, 0.5);
  }
  
  .react-datepicker__day--in-range {
    background-color: rgba(33, 170, 115, 0.8);
    color: white;
  }
  
  .react-datepicker__day--range-start,
  .react-datepicker__day--range-end,
  .react-datepicker__day--selecting-range-start,
  .react-datepicker__day--selecting-range-end {
    background-color: #21AA73;
    color: white;
  }
  
  .react-datepicker__navigation {
    top: 10px;
  }
  
  .react-datepicker__navigation-icon::before {
    border-color: #21AA73;
  }
  
  .react-datepicker__navigation:hover *::before {
    border-color: #21AA73;
  }
`; */

const Payments = (props) => {

  const [status, setStatus] = useState('all')
  const [searchInput, setSearchInput] = useState('')
  const [search, setSearch] = useState('')
  const [client, setClient] = useState(props.clientFilter || 'all')
  const [location, setLocation] = useState(props.locationFilter || 'all')
  const [startDate, setStartDate] = useState(() => {
    // Check if there's a saved date range in localStorage
    const savedStartDate = localStorage.getItem('enforcePlus_startDate');
    return savedStartDate ? new Date(savedStartDate) : startOfDay(new Date());
  });
  const [endDate, setEndDate] = useState(() => {
    // Check if there's a saved date range in localStorage
    const savedEndDate = localStorage.getItem('enforcePlus_endDate');
    return savedEndDate ? new Date(savedEndDate) : endOfDay(new Date());
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const [sortBy, setSortBy] = useState('dateDesc')
  const [page, setPage] = useState(1)
  const [pageSize] = useState(100)
  const [endablePdfMode, setEndablePdfMode] = useState(false);
  const [showDatePickerModal, setShowDatePickerModal] = useState(false);
  const [activeCalendar, setActiveCalendar] = useState(null);

  // Add ref for column selector
  const columnSelectorRef = useRef(null);

  // Snapshot of dates at the moment the date-picker modal was opened, so Cancel
  // can restore them. Without this, picker clicks already mutate startDate/endDate
  // before Apply, making "Cancel" misleading.
  const preModalDatesRef = useRef({ startDate: null, endDate: null });
  
  // Add column visibility state
  const [visibleColumns, setVisibleColumns] = useState(() => {
    const defaults = {
      license_plate: true,
      id: false,
      date_time: true,
      location: true,
      type: false,
      violation_fees: true,
      service_fees: true,
      total: true,
      // OOB-540: the Stripe PaymentIntent id, so a monthly export can be matched
      // row-for-row against Stripe's own export. Off by default — only the people
      // doing reconciliation need it.
      stripe_reference: false
    };
    // Saved preferences are merged ON TOP of the defaults rather than replacing
    // them: a browser holding an older object would otherwise leave any newly
    // added column permanently undefined, and its checkbox dead.
    const savedPreferences = localStorage.getItem('payments_visible_columns');
    if (savedPreferences) {
      try {
        return {...defaults, ...JSON.parse(savedPreferences)};
      } catch (e) {
        console.error("Error parsing saved column preferences", e);
      }
    }
    return defaults;
  });
  const [showColumnSelector, setShowColumnSelector] = useState(false);

  // Save column preferences whenever they change
  useEffect(() => {
    localStorage.setItem('payments_visible_columns', JSON.stringify(visibleColumns));
  }, [visibleColumns]);

  // Add click outside handler for column selector
  useEffect(() => {
    function handleClickOutside(event) {
      if (columnSelectorRef.current && !columnSelectorRef.current.contains(event.target)) {
        setShowColumnSelector(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const allColumns = [
    { id: 'license_plate', label: 'License plate' },
    { id: 'id', label: '#ID' },
    { id: 'date_time', label: 'Date/Time' },
    { id: 'location', label: 'Location' },
    { id: 'type', label: 'Type' },
    { id: 'violation_fees', label: 'Violation fees' },
    { id: 'service_fees', label: 'Service fees' },
    { id: 'total', label: 'Total' },
    { id: 'stripe_reference', label: 'Stripe payment ID' }
  ];

  // Update csvHeader to use visible columns
  const csvHeader = allColumns
    .filter(column => visibleColumns[column.id])
    .map(column => column.label);

  const generateFileData = () => {
    let paymentsTemp = [...filteredPayments]
    let csvDataArray = paymentsTemp.map(payment => {
      const rowData = [];
      if (visibleColumns.license_plate) rowData.push(payment.license_plate);
      if (visibleColumns.id) rowData.push(payment.violation_number);
      if (visibleColumns.date_time) rowData.push(moment(payment.payment_on).format('MM/DD/Y h:mm a'));
      if (visibleColumns.location) rowData.push(payment.location_name);
      if (visibleColumns.type) rowData.push(payment.payment.type);
      if (visibleColumns.violation_fees) rowData.push(payment.payment_on ? parseFloat(parseFloat(payment.payment.amount) - ((payment?.payment?.card_last_four) ? parseFloat(payment.service_fee) : 0)).toFixed(2) : parseFloat(payment.total).toFixed(2));
      if (visibleColumns.service_fees) rowData.push(payment.payment_on ? parseFloat(parseFloat(payment.service_fee)).toFixed(2) : parseFloat(payment.total).toFixed(2));
      if (visibleColumns.total) rowData.push(payment.payment_on ? parseFloat(parseFloat(payment.payment.amount)).toFixed(2) : parseFloat(payment.total).toFixed(2));
      // Only card payments have one — cash/manual rows export as blank.
      if (visibleColumns.stripe_reference) rowData.push(payment.payment?.reference || '');
      return rowData;
    });
    return [csvHeader, ...csvDataArray]
  }

  const generateList = () => {
    if (endablePdfMode) {
      return filteredPayments
    } else {
      return filteredPayments.slice((page - 1) * pageSize, ((page - 1) * pageSize) + pageSize);
    }
  }

  const getTargetElement = () => document.getElementById('content-id');

  const generateFilePdf = () => {
    const options = {
      method: 'save',
      resolution: Resolution.NORMAL,
      page: {
        margin: Margin.SMALL,
        format: 'A4',
        orientation: 'portrait',
      },
      canvas: {
        mimeType: 'image/jpeg',
        qualityRatio: 1
      },
      overrides: {
        pdf: {
          compress: true
        },
        canvas: {
          useCORS: true
        }
      },
      filename: 'enforceplus_payments.pdf'
    };

    setEndablePdfMode(true);
    setTimeout(() => {
      generatePDF(getTargetElement, options);
      setTimeout(() => {
        setEndablePdfMode(false);
      }, 1000);
    }, 1000);
  }

  useEffect(() => {
    props.getAllPayments(startDate, endDate)
    // Store the date range in Redux
    props.setDateRangeFilter({ startDate, endDate })
    document.title = 'Payments: EnforcePlus admin';
    !accessCheck(props.user, 'payments') && (window.location.href = '/')
    props.clearCitation()
  }, [])

  // Fetch payments only on explicit user intent (Apply button or preset).
  // Prior auto-fetch on [startDate, endDate] fired twice per range pick (once per
  // calendar click) and made each click feel laggy.
  const handleApplyDateRange = React.useCallback(() => {
    props.getAllPayments(startDate, endDate)
    props.setDateRangeFilter({ startDate, endDate })
    setShowDatePickerModal(false)
    setActiveCalendar(null)
    // dispatch refs from bindActionCreators are stable for the lifetime of the mount
  }, [startDate, endDate])

  const handleOpenDatePickerModal = React.useCallback(() => {
    preModalDatesRef.current = { startDate, endDate }
    setShowDatePickerModal(true)
  }, [startDate, endDate])

  const handleCancelDatePickerModal = React.useCallback(() => {
    const snapshot = preModalDatesRef.current
    if (snapshot.startDate && snapshot.endDate) {
      setStartDate(snapshot.startDate)
      setEndDate(snapshot.endDate)
    }
    setActiveCalendar(null)
    setShowDatePickerModal(false)
  }, [])

  // useEffect(() => {
  //   if (props.addedLocation) {
  //     setAddedLocation(true);
  //     setTimeout(() => {
  //       setAddedLocation(false)
  //       props.clearAddedLocation()
  //     }, 10000);
  //   }
  //   if (props.updatedLocation) {
  //     setUpdatedLocation(true);
  //     setTimeout(() => {
  //       setUpdatedLocation(false)
  //       props.clearAddedLocation()
  //     }, 10000);
  //   }
  // }, [props.addedLocation, props.updatedLocation])

  
  
  // Debounce search input → reduces filter+sort runs from one-per-keystroke to
  // one-per-pause. The text input writes to searchInput; the filter reads search.
  useEffect(() => {
    const id = setTimeout(() => setSearch(searchInput), 250)
    return () => clearTimeout(id)
  }, [searchInput])

  // Side effects extracted from the old filterPayments — Redux dispatches must
  // not run inside useMemo's callback (it executes during render).
  useEffect(() => { props.setClientFilter(client) }, [client])
  useEffect(() => { props.setLocationFilter(location) }, [location])

  const filteredPayments = React.useMemo(() => {
    const source = props.payments
    if (!(source?.length > 0)) return []
    let sortedPayments = [...source];
    if (search !== '') {
      sortedPayments = sortedPayments.filter(payment => (
        payment.violation_number.toLowerCase().indexOf(search.toLowerCase()) !== -1
        || payment.license_plate.toLowerCase().indexOf(search.toLowerCase()) !== -1
        || payment.license_plate.toLowerCase().indexOf(search.toLowerCase()) !== -1
        || (props.users?.find(user => user.id === payment.user)?.name || '').toLowerCase().indexOf(search.toLowerCase()) !== -1
      ))
    }
    if (client !== 'all') {
      sortedPayments = sortedPayments.filter(payment => payment.client === client)
    }
    if (location !== 'all') {
      sortedPayments = sortedPayments.filter(payment => payment.location === location)
    }
    if (sortBy === 'dateDesc') {
      sortedPayments = sortedPayments.sort((a, b) => a.payment_on && b.payment_on && moment(a.payment_on).isBefore(moment(b.payment_on)) ? 1 : -1);
    }
    if (sortBy === 'dateAsc') {
      sortedPayments = sortedPayments.sort((a, b) => a.payment_on && b.payment_on && moment(a.payment_on).isBefore(moment(b.payment_on)) ? -1 : 1);
    }
    if (sortBy === 'licenseAsc') {
      sortedPayments = sortedPayments.sort((a, b) => a.license_plate.localeCompare(b.license_plate));
    }
    if (sortBy === 'licenseDesc') {
      sortedPayments = sortedPayments.sort((a, b) => b.license_plate.localeCompare(a.license_plate));
    }
    if (sortBy === 'idAsc') {
      sortedPayments = sortedPayments.sort((a, b) => a.violation_number.localeCompare(b.violation_number));
    }
    if (sortBy === 'idDesc') {
      sortedPayments = sortedPayments.sort((a, b) => b.violation_number.localeCompare(a.violation_number));
    }
    if (sortBy === 'locationAsc') {
      sortedPayments = sortedPayments.sort((a, b) => a.location_name.localeCompare(b.location_name));
    }
    if (sortBy === 'locationDesc') {
      sortedPayments = sortedPayments.sort((a, b) => b.location_name.localeCompare(a.location_name));
    }
    if (sortBy === 'violationAsc') {
      sortedPayments = sortedPayments.sort((a, b) => (a.payment_on ? parseFloat(a.payment.amount - ((a.payment?.card_last_four) ? a.service_fee : 0)) : parseFloat(a.violations_total)) > (b.payment_on ? parseFloat(b.payment.amount - ((b.payment?.card_last_four) ? b.service_fee : 0)) : parseFloat(b.violations_total)) ? 1 : -1);
    }
    if (sortBy === 'violationDesc') {
      sortedPayments = sortedPayments.sort((a, b) => (a.payment_on ? parseFloat(a.payment.amount - ((a.payment?.card_last_four) ? a.service_fee : 0)) : parseFloat(a.violations_total)) > (b.payment_on ? parseFloat(b.payment.amount - ((b.payment?.card_last_four) ? b.service_fee : 0)) : parseFloat(b.violations_total)) ? -1 : 1);
    }
    if (sortBy === 'feeAsc') {
      sortedPayments = sortedPayments.sort((a, b) => (a.payment_on ? parseFloat(a.service_fee) : parseFloat(a.violations_total)) > (b.payment_on ? parseFloat(b.service_fee) : parseFloat(b.violations_total)) ? 1 : -1);
    }
    if (sortBy === 'feeDesc') {
      sortedPayments = sortedPayments.sort((a, b) => (a.payment_on ? parseFloat(a.service_fee) : parseFloat(a.violations_total)) > (b.payment_on ? parseFloat(b.service_fee) : parseFloat(b.violations_total)) ? -1 : 1);
    }
    if (sortBy === 'totalAsc') {
      sortedPayments = sortedPayments.sort((a, b) => (a.payment_on ? parseFloat(a.payment.amount) : parseFloat(a.violations_total)) > (b.payment_on ? parseFloat(b.payment.amount) : parseFloat(b.violations_total)) ? 1 : -1);
    }
    if (sortBy === 'totalDesc') {
      sortedPayments = sortedPayments.sort((a, b) => (a.payment_on ? parseFloat(a.payment.amount) : parseFloat(a.violations_total)) > (b.payment_on ? parseFloat(b.payment.amount) : parseFloat(b.violations_total)) ? -1 : 1);
    }

    return sortedPayments
  }, [props.payments, search, client, location, sortBy, props.users])

  const paymentAction = (payment, action) => {
    if (action === 'view_receipt') {
      window.open(payment.payment.receipt_url)
    }
    if (action === 'view_citation') {
      window.location.href = './citation/' + payment.violation_number
    }
  }

  // Normalize to start/end of day in browser-local TZ. react-datepicker emits a
  // Date at 00:00 local for the picked day, which after toISOString() becomes
  // the prior day's data window — that's the +1-day workaround bug.
  const handleDateChange = React.useCallback((type, date) => {
    if (!date) return;

    if (type === 'start') {
      const start = startOfDay(date);
      setStartDate(start);
      localStorage.setItem('enforcePlus_startDate', start.toISOString());
    } else {
      const end = endOfDay(date);
      setEndDate(end);
      localStorage.setItem('enforcePlus_endDate', end.toISOString());
    }
  }, []);

  // Memoize preset handler
  const handlePresetClick = React.useCallback((preset) => {
    const today = new Date();
    let start, end;
    
    switch(preset) {
      case 'today':
        start = startOfDay(today);
        end = endOfDay(today);
        break;
      case 'yesterday':
        start = startOfDay(sub(today, { days: 1 }));
        end = endOfDay(sub(today, { days: 1 }));
        break;
      case 'lastWeek':
        start = startOfDay(sub(today, { days: 6 }));
        end = endOfDay(today);
        break;
      case 'lastMonth':
        start = startOfDay(sub(today, { days: 29 }));
        end = endOfDay(today);
        break;
      default:
        return;
    }
    
    setStartDate(start);
    setEndDate(end);
    localStorage.setItem('enforcePlus_startDate', start.toISOString());
    localStorage.setItem('enforcePlus_endDate', end.toISOString());
    props.getAllPayments(start, end);
    props.setDateRangeFilter({ startDate: start, endDate: end });
    setShowDatePickerModal(false);
    // dispatch refs from bindActionCreators are stable for the lifetime of the mount
  }, []);

  // Memoize formatted dates
  const formattedDateRange = React.useMemo(() => {
    return `${moment(startDate).format('D MMM')} - ${moment(endDate).format('D MMM YY')}`;
  }, [startDate, endDate]);

  return (
    <Container fluid className="main-content-container px-4">
      <style>
        {`
          .payment-row:hover {
            background-color: rgba(33, 170, 115, 0.03);
            cursor: pointer;
          }
          
          .table th {
            border-top: none;
          }
          
          .table td {
            vertical-align: middle;
          }
          
          .actions-dropdown-right .dropdown-menu {
            right: 0 !important;
            left: auto !important;
            transform: none !important;
          }
          
          .filter-active .select__control {
            border-color: #21AA73 !important;
            border-width: 2px !important;
            box-shadow: 0 0 5px rgba(33, 170, 115, 0.2) !important;
            background-color: rgba(33, 170, 115, 0.05) !important;
          }
          
          /* DatePicker styles now handled by the EnhancedDateRangePicker component */
        `}
      </style>
      {/* Page Header */}
      <Row noGutters className="page-header py-4">
        <PageTitle title="Payments" className="text-sm-left mb-3" />
      </Row>

      {/* First Row of Posts */}
      <Row>
        <Col>
          <Card small className="mb-4" style={{
            borderRadius: '6px', 
            boxShadow: '0 1px 10px rgba(0,0,0,0.05)', 
            border: '1px solid #eaedf3',
            margin: '0 0 20px 0'
          }}>
            <CardHeader className="border-bottom">
              <Row>
                <Col xs={12} className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <h6 className="m-0 font-weight-bold d-flex align-items-center">
                      <FontAwesomeIcon icon={faFileInvoiceDollar} className="mr-2" style={{color: '#21AA73', opacity: 0.8}} />
                      ({filteredPayments.length})
                    </h6>
                  </div>
                  <div className="d-flex align-items-center">
                {/* Client selector first */}
                {props.user.type === 'super' && (
                  <div style={{ width: '150px', marginRight: '10px' }}>
                    <Select
                      id="feClients"
                      className={client !== 'all' ? "basic-select filter-active" : "basic-select"}
                      classNamePrefix="select"
                      placeholder="All clients"
                      isClearable={false}
                      isSearchable={true}
                      value={client === 'all' 
                        ? { value: 'all', label: 'All clients' } 
                        : props.clients && props.clients.find(c => c.id === client) 
                          ? { value: client, label: props.clients.find(c => c.id === client).name }
                          : { value: 'all', label: 'All clients' }
                      }
                      onChange={(selectedOption) => setClient(selectedOption.value)}
                      options={[
                        { value: 'all', label: 'All clients' },
                        ...props.clients && props.clients.sort((a, b) => a.name.localeCompare(b.name)).map(c => ({
                          value: c.id,
                          label: c.name
                        })) || []
                      ]}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          borderColor: state.isFocused ? 'rgba(33, 170, 115, 0.4)' : undefined,
                          boxShadow: state.isFocused ? '0 0 0 1px rgba(33, 170, 115, 0.4)' : undefined,
                          '&:hover': {
                            borderColor: 'rgba(33, 170, 115, 0.4)'
                          }
                        }),
                        option: (base, state) => ({
                          ...base,
                          backgroundColor: state.isSelected ? 'rgba(33, 170, 115, 0.1)' : state.isFocused ? 'rgba(33, 170, 115, 0.05)' : null,
                          color: state.isSelected ? '#21AA73' : base.color
                        }),
                        menuList: (base) => ({
                          ...base,
                          padding: '5px'
                        }),
                        menu: (base) => ({
                          ...base,
                          boxShadow: '0 3px 12px rgba(0,0,0,0.08)',
                          borderRadius: '6px',
                          border: '1px solid #eaedf3',
                          backgroundColor: '#fff'
                        }),
                        indicatorSeparator: () => ({
                          display: 'none'
                        }),
                        dropdownIndicator: (base, state) => ({
                          ...base,
                          color: state.isFocused ? '#21AA73' : '#818ea3',
                          transition: 'color 0.2s ease',
                          '&:hover': {
                            color: '#21AA73'
                          }
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color: '#495057'
                        })
                      }}
                    />
                  </div>
                )}
                
                    {/* Date Range Button */}
                    <Button
                      theme="white"
                      className="d-flex align-items-center mr-2"
                      style={{
                        borderColor: '#e1e5eb',
                        height: '38px',
                        padding: '0 12px',
                        fontSize: '14px'
                      }}
                      onClick={handleOpenDatePickerModal}
                    >
                      <FontAwesomeIcon icon={faCalendar} className="mr-2" style={{ color: '#21AA73' }} />
                      {formattedDateRange}
                    </Button>

                    {/* Location Selector */}
                    {!(props.user?.embed && props.user?.location) && (
                    <div style={{ width: '150px', marginRight: '10px' }}>
                  <Select
                    id="feLocations"
                    className={location !== 'all' ? "basic-select filter-active" : "basic-select"}
                    classNamePrefix="select"
                    placeholder="All locations"
                    isClearable={false}
                    isSearchable={true}
                    value={location === 'all' 
                      ? { value: 'all', label: 'All locations' } 
                      : props.locations && props.locations.find(loc => loc.id === location) 
                        ? { value: location, label: props.locations.find(loc => loc.id === location).name }
                        : { value: 'all', label: 'All locations' }
                    }
                    onChange={(selectedOption) => setLocation(selectedOption.value)}
                    options={[
                      { value: 'all', label: 'All locations' },
                      ...props.locations && props.locations.sort((a, b) => a.name.localeCompare(b.name)).map(loc => ({
                        value: loc.id,
                        label: loc.name
                      })) || []
                    ]}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        borderColor: state.isFocused ? 'rgba(33, 170, 115, 0.4)' : undefined,
                        boxShadow: state.isFocused ? '0 0 0 1px rgba(33, 170, 115, 0.4)' : undefined,
                        '&:hover': {
                          borderColor: 'rgba(33, 170, 115, 0.4)'
                        }
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isSelected ? 'rgba(33, 170, 115, 0.1)' : state.isFocused ? 'rgba(33, 170, 115, 0.05)' : null,
                        color: state.isSelected ? '#21AA73' : base.color
                      }),
                      menuList: (base) => ({
                        ...base,
                        padding: '5px'
                      }),
                      menu: (base) => ({
                        ...base,
                        boxShadow: '0 3px 12px rgba(0,0,0,0.08)',
                        borderRadius: '6px',
                        border: '1px solid #eaedf3',
                        backgroundColor: '#fff'
                      }),
                      indicatorSeparator: () => ({
                        display: 'none'
                      }),
                      dropdownIndicator: (base, state) => ({
                        ...base,
                        color: state.isFocused ? '#21AA73' : '#818ea3',
                        transition: 'color 0.2s ease',
                        '&:hover': {
                          color: '#21AA73'
                        }
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color: '#495057'
                      })
                    }}
                  />
                </div>
                    )}

                    {/* Search Box */}
                      <div className="search-container mr-3" style={{ position: 'relative', maxWidth: '100%', flex: '1' }}>
                        <input
                          type="text"
                          placeholder="Search payments..."
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                          style={{
                            width: '100%',
                            padding: '8px 32px 8px 36px',
                            fontSize: '14px',
                            border: '1px solid #dfe3e9',
                            borderRadius: '4px',
                            backgroundColor: '#f8f9fa',
                            transition: 'all 0.2s ease',
                            outline: 'none'
                          }}
                          onFocus={(e) => {
                            e.target.style.backgroundColor = '#fff';
                            e.target.style.boxShadow = '0 0 0 0.2rem rgba(33, 170, 115, 0.1)';
                            e.target.style.borderColor = 'rgba(33, 170, 115, 0.4)';
                          }}
                          onBlur={(e) => {
                            e.target.style.backgroundColor = '#f8f9fa';
                            e.target.style.boxShadow = 'none';
                            e.target.style.borderColor = '#dfe3e9';
                          }}
                        />
                        <FontAwesomeIcon 
                          icon={faSearch} 
                          style={{
                            position: 'absolute',
                            left: '12px',
                            top: '10px',
                            color: '#818ea3',
                            transition: 'color 0.2s ease'
                          }}
                        />
                        {searchInput && (
                          <FontAwesomeIcon
                            icon={faTimes}
                            style={{
                              position: 'absolute',
                              right: '12px',
                              top: '10px',
                              color: '#818ea3',
                              cursor: 'pointer',
                              transition: 'color 0.2s ease'
                            }}
                            onClick={() => { setSearchInput(''); setSearch('') }}
                            onMouseEnter={(e) => e.currentTarget.style.color = '#21AA73'}
                            onMouseLeave={(e) => e.currentTarget.style.color = '#818ea3'}
                          />
                        )}
                      </div>

                    {/* Download Button */}
                      <div style={{ width: '220px', minWidth: '220px', flexShrink: 0 }}>
                        <DownloadButton
                          filename={"enforceplus_payments"}
                          fileData={generateFileData()}
                          showPdfLoading={endablePdfMode}
                          createPdf={() => generateFilePdf()}
                        />
                    </div>
                      </div>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody className="px-4">
              {props.gettingAllPayments ? (
                    <div className="text-center py-5">
                      <ActivityIndicator size="large" />
                      <p className="mt-3 text-muted">Loading payments...</p>
                    </div>
              ) : (
                <>  
                    <div className="table-responsive" id="content-id">
                  <table className="table mb-0">
                        <thead className="bg-light">
                          <tr>
                            {visibleColumns.license_plate && (
                              <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                                <div onClick={() => setSortBy(sortBy !== 'licenseAsc' ? 'licenseAsc' : 'licenseDesc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                                  License plate
                                  {sortBy === 'licenseAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                                  {sortBy === 'licenseDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                                </div>
                              </th>
                            )}
                            {visibleColumns.id && (
                              <th scope="col" className="border-0 d-none d-md-table-cell" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                                <div onClick={() => setSortBy(sortBy !== 'idAsc' ? 'idAsc' : 'idDesc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                                  #ID
                                  {sortBy === 'idAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                                  {sortBy === 'idDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                                </div>
                              </th>
                            )}
                            {visibleColumns.date_time && (
                              <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                                <div onClick={() => setSortBy(sortBy !== 'dateDesc' ? 'dateDesc' : 'dateAsc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                                  Date/Time
                                  {sortBy === 'dateDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                                  {sortBy === 'dateAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                                </div>
                              </th>
                            )}
                            {visibleColumns.location && (
                              <th scope="col" className="border-0 d-none d-md-table-cell" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                                <div onClick={() => setSortBy(sortBy !== 'locationAsc' ? 'locationAsc' : 'locationDesc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                                  Location
                                  {sortBy === 'locationAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                                  {sortBy === 'locationDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                                </div>
                              </th>
                            )}
                            {visibleColumns.type && (
                              <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                                Type
                              </th>
                            )}
                            {visibleColumns.violation_fees && (
                              <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                                Violation fees
                              </th>
                            )}
                            {visibleColumns.service_fees && (
                              <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                                Service fees
                              </th>
                            )}
                            {visibleColumns.total && (
                              <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                                Total
                              </th>
                            )}
                            {visibleColumns.stripe_reference && (
                              <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                                Stripe payment ID
                              </th>
                            )}
                            { !endablePdfMode && (
                              <th scope="col" className="border-0 text-right d-none d-md-table-cell" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                                <div ref={columnSelectorRef} style={{ position: 'relative', display: 'inline-block', marginRight: '12px' }}>
                                  <Button
                                    theme="white"
                                    size="sm"
                                    style={{
                                      borderColor: '#dfe3e9',
                                      color: '#818ea3',
                                      height: '24px',
                                      padding: '0 8px',
                                      fontSize: '11px',
                                      minWidth: '80px'
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setShowColumnSelector(!showColumnSelector);
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faColumns} className="mr-1" size="sm" />
                                    Columns
                                  </Button>

                                  {showColumnSelector && (
                                    <div 
                                      style={{
                                        position: 'absolute',
                                        top: 'calc(100% + 4px)',
                                        right: '0',
                                        width: '220px',
                                        backgroundColor: '#fff',
                                        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
                                        borderRadius: '6px',
                                        border: '1px solid #eaedf3',
                                        zIndex: 1050,
                                        padding: '12px'
                                      }}
                                    >
                                      <div style={{ 
                                        borderBottom: '1px solid #eaedf3', 
                                        paddingBottom: '8px', 
                                        marginBottom: '8px',
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        color: '#3D5170'
                                      }}>
                                        Show/Hide Columns
                                      </div>
                                      {allColumns.map(column => (
                                        <div 
                                          key={column.id}
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '6px 0',
                                            cursor: 'pointer',
                                            transition: 'background-color 0.2s ease',
                                            margin: '0 -12px',
                                            padding: '6px 12px'
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = 'rgba(33, 170, 115, 0.05)';
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                          }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setVisibleColumns(prev => ({
                                              ...prev,
                                              [column.id]: !prev[column.id]
                                            }));
                                          }}
                                        >
                                          <div style={{
                                            width: '16px',
                                            height: '16px',
                                            border: '2px solid',
                                            borderColor: visibleColumns[column.id] ? '#21AA73' : '#dfe3e9',
                                            borderRadius: '3px',
                                            marginRight: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: visibleColumns[column.id] ? '#21AA73' : 'transparent',
                                            transition: 'all 0.2s ease'
                                          }}>
                                            {visibleColumns[column.id] && (
                                              <FontAwesomeIcon 
                                                icon={faCheck} 
                                                style={{ 
                                                  color: '#fff',
                                                  fontSize: '10px'
                                                }} 
                                              />
                                            )}
                                          </div>
                                          <span style={{
                                            fontSize: '13px',
                                            color: '#495057'
                                          }}>
                                            {column.label}
                                          </span>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {props.payments && filteredPayments.length > 0 && generateList().map(payment => {
                            return (
                              <React.Fragment key={payment.id}>
                                <tr style={{transition: 'background-color 0.2s ease'}} className="payment-row">
                                  {visibleColumns.license_plate && (
                                    <td style={{padding: '12px'}}>
                                      <span style={{fontWeight: '500'}}>{payment.license_plate}</span>
                                    </td>
                                  )}
                                  {visibleColumns.id && (
                                    <td style={{padding: '12px'}} className={"d-none d-md-table-cell"}>
                                      <span style={{color: '#495057'}}>{payment.violation_number}</span>
                                    </td>
                                  )}
                                  {visibleColumns.date_time && (
                                    <td style={{padding: '12px'}}>
                                      <span style={{color: '#495057'}}>{moment(payment.payment_on).format('MM/DD/Y')}
                                        <div style={{fontSize: '12px', color: '#818ea3'}}>{moment(payment.payment_on).format('h:mm a')}</div>
                                      </span>
                                    </td>
                                  )}
                                  {visibleColumns.location && (
                                    <td style={{padding: '12px'}} className={"d-none d-md-table-cell"}>
                                      <span style={{color: '#495057'}}>{payment.location_name}</span>
                                    </td>
                                  )}
                                  {visibleColumns.type && (
                                    <td style={{padding: '12px'}}>
                                      <span style={{color: '#495057'}}>{payment.payment.type}</span>
                                    </td>
                                  )}
                                  {visibleColumns.violation_fees && (
                                    <td style={{padding: '12px'}}>
                                      <span style={{fontWeight: '500'}}>${parseFloat(parseFloat(payment.payment.amount) - ((payment?.payment?.card_last_four) ? parseFloat(payment.service_fee) : 0)).toFixed(2)}</span>
                                    </td>
                                  )}
                                  {visibleColumns.service_fees && (
                                    <td style={{padding: '12px'}}>
                                      <span style={{fontWeight: '500'}}>${parseFloat(payment.service_fee).toFixed(2)}</span>
                                    </td>
                                  )}
                                  {visibleColumns.total && (
                                    <td style={{padding: '12px'}}>
                                      <span style={{fontWeight: '500'}}>${parseFloat(payment.payment.amount).toFixed(2)}</span>
                                    </td>
                                  )}
                                  {visibleColumns.stripe_reference && (
                                    <td style={{padding: '12px'}}>
                                      <span style={{fontSize: 12, fontFamily: 'monospace', color: '#495057'}}>
                                        {payment.payment?.reference || '—'}
                                      </span>
                                    </td>
                                  )}
                                  { !endablePdfMode &&
                                    <td className={"text-right d-none d-md-table-cell"}>
                                      <RowActions>
                                          <RowActions.Item onClick={(e) => {
                                            e.stopPropagation();
                                            paymentAction(payment, 'view_receipt');
                                          }}>
                                            <FontAwesomeIcon icon={faFileInvoiceDollar} className="mr-2" style={{color: '#21AA73'}} />
                                            View receipt
                                          </RowActions.Item>
                                          <RowActions.Item onClick={(e) => {
                                            e.stopPropagation();
                                            paymentAction(payment, 'view_citation');
                                          }}>
                                            <FontAwesomeIcon icon={faFile} className="mr-2" style={{color: '#818ea3'}} />
                                            View citation
                                          </RowActions.Item>
                                        </RowActions>
                                    </td>
                                  }
                                </tr>
                              </React.Fragment>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                </>
                  )}
                </CardBody>
              </Card>
              <Pagination
                data={filteredPayments}
                pageSize={pageSize}
                page={page}
                onPageChange={(newPage) => setPage(newPage)}      
              />
        </Col>
      </Row>

      {/* Date Picker Modal */}
      <Modal
        open={showDatePickerModal}
        toggle={handleCancelDatePickerModal}
        className="date-picker-modal"
        size="lg"
      >
        <ModalHeader toggle={handleCancelDatePickerModal} className="border-bottom">
          <FontAwesomeIcon icon={faCalendar} className="mr-2" style={{ color: '#21AA73' }} />
          Select Date Range
        </ModalHeader>
        <ModalBody className="p-4">
          <Row>
            <Col md="8">
              <Card className="mb-0" style={{ boxShadow: 'none', border: '1px solid #eaedf3' }}>
                <CardBody className="p-4">
                  <div className="d-flex flex-column" style={{ gap: '16px' }}>
                    <div>
                      <label className="d-block mb-2" style={{ fontSize: '13px', color: '#818ea3', fontWeight: '500' }}>Start Date</label>
                      <Button 
                        block
                        theme="white"
                        style={{
                          borderColor: activeCalendar === 'start' ? '#21AA73' : '#e1e5eb',
                          backgroundColor: '#fff',
                          textAlign: 'left',
                          position: 'relative',
                          height: '38px',
                          boxShadow: activeCalendar === 'start' ? '0 0 0 3px rgba(33, 170, 115, 0.1)' : 'none'
                        }}
                        onClick={() => setActiveCalendar(activeCalendar === 'start' ? null : 'start')}
                      >
                        <div className="d-flex align-items-center">
                          <FontAwesomeIcon icon={faCalendar} className="mr-2" style={{ color: '#21AA73' }} />
                          <span style={{ color: '#495057' }}>
                            {startDate ? moment(startDate).format('MMM D, YYYY') : 'Select start date'}
                          </span>
                        </div>
                      </Button>
                      {activeCalendar === 'start' && (
                        <div style={{ 
                          position: 'absolute', 
                          zIndex: 1000,
                          marginTop: '8px',
                          backgroundColor: '#fff',
                          borderRadius: '6px',
                          boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
                          border: '1px solid #eaedf3'
                        }}>
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => {
                              handleDateChange('start', date);
                              setActiveCalendar('end');
                            }}
                            maxDate={endDate || new Date()}
                            inline
                            calendarClassName="single-date-calendar"
                          />
                        </div>
                      )}
                    </div>
                    <div>
                      <label className="d-block mb-2" style={{ fontSize: '13px', color: '#818ea3', fontWeight: '500' }}>End Date</label>
                      <Button 
                        block
                        theme="white"
                        style={{
                          borderColor: activeCalendar === 'end' ? '#21AA73' : '#e1e5eb',
                          backgroundColor: '#fff',
                          textAlign: 'left',
                          position: 'relative',
                          height: '38px',
                          boxShadow: activeCalendar === 'end' ? '0 0 0 3px rgba(33, 170, 115, 0.1)' : 'none'
                        }}
                        onClick={() => setActiveCalendar(activeCalendar === 'end' ? null : 'end')}
                      >
                        <div className="d-flex align-items-center">
                          <FontAwesomeIcon icon={faCalendar} className="mr-2" style={{ color: '#21AA73' }} />
                          <span style={{ color: '#495057' }}>
                            {endDate ? moment(endDate).format('MMM D, YYYY') : 'Select end date'}
                          </span>
                        </div>
                      </Button>
                      {activeCalendar === 'end' && (
                        <div style={{ 
                          position: 'absolute', 
                          zIndex: 1000,
                          marginTop: '8px',
                          backgroundColor: '#fff',
                          borderRadius: '6px',
                          boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
                          border: '1px solid #eaedf3'
                        }}>
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => {
                              handleDateChange('end', date);
                              setActiveCalendar(null);
                            }}
                            minDate={startDate}
                            maxDate={new Date()}
                            inline
                            calendarClassName="single-date-calendar"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <style>
                    {`
                      .single-date-calendar {
                        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
                        border: none !important;
                        width: 100%;
                      }
                      .single-date-calendar .react-datepicker__header {
                        background-color: #fff;
                        border-bottom: 1px solid #eaedf3;
                        padding-top: 10px;
                      }
                      .single-date-calendar .react-datepicker__current-month {
                        color: #495057;
                        font-weight: 600;
                        font-size: 14px;
                      }
                      .single-date-calendar .react-datepicker__day-name {
                        color: #818ea3;
                        font-size: 12px;
                        margin: 3px;
                      }
                      .single-date-calendar .react-datepicker__day {
                        color: #495057;
                        margin: 3px;
                        font-size: 13px;
                        width: 32px;
                        height: 32px;
                        line-height: 32px;
                      }
                      .single-date-calendar .react-datepicker__day:hover {
                        background-color: rgba(33, 170, 115, 0.1);
                        border-radius: 50%;
                      }
                      .single-date-calendar .react-datepicker__day--selected {
                        background-color: #21AA73;
                        border-radius: 50%;
                        color: white;
                      }
                      .single-date-calendar .react-datepicker__day--keyboard-selected {
                        background-color: rgba(33, 170, 115, 0.2);
                        border-radius: 50%;
                        color: #21AA73;
                      }
                      .single-date-calendar .react-datepicker__navigation {
                        top: 8px;
                      }
                      .single-date-calendar .react-datepicker__navigation-icon::before {
                        border-color: #21AA73;
                      }
                    `}
                  </style>
                </CardBody>
              </Card>
            </Col>
            <Col md="4">
              <Card className="mb-0" style={{ boxShadow: 'none', border: '1px solid #eaedf3' }}>
                <CardHeader className="border-bottom" style={{ backgroundColor: '#f8f9fa' }}>
                  <h6 className="m-0" style={{ fontSize: '13px', fontWeight: '600', color: '#495057' }}>Quick Select</h6>
                </CardHeader>
                <CardBody className="p-3">
                  <div className="d-flex flex-column" style={{ gap: '8px' }}>
                    <Button 
                      theme="light" 
                      size="sm" 
                      block
                      style={{
                        fontSize: '13px',
                        color: '#21AA73',
                        borderColor: 'rgba(33, 170, 115, 0.3)',
                        textAlign: 'left',
                        padding: '10px 12px',
                        backgroundColor: '#fff'
                      }} 
                      onClick={() => handlePresetClick('today')}
                    >
                      Today
                    </Button>
                    <Button 
                      theme="light" 
                      size="sm"
                      block 
                      style={{
                        fontSize: '13px',
                        color: '#21AA73',
                        borderColor: 'rgba(33, 170, 115, 0.3)',
                        textAlign: 'left',
                        padding: '10px 12px',
                        backgroundColor: '#fff'
                      }} 
                      onClick={() => handlePresetClick('yesterday')}
                    >
                      Yesterday
                    </Button>
                    <Button 
                      theme="light" 
                      size="sm"
                      block 
                      style={{
                        fontSize: '13px',
                        color: '#21AA73',
                        borderColor: 'rgba(33, 170, 115, 0.3)',
                        textAlign: 'left',
                        padding: '10px 12px',
                        backgroundColor: '#fff'
                      }} 
                      onClick={() => handlePresetClick('lastWeek')}
                    >
                      Last 7 days
                    </Button>
                    <Button 
                      theme="light" 
                      size="sm"
                      block 
                      style={{
                        fontSize: '13px',
                        color: '#21AA73',
                        borderColor: 'rgba(33, 170, 115, 0.3)',
                        textAlign: 'left',
                        padding: '10px 12px',
                        backgroundColor: '#fff'
                      }} 
                      onClick={() => handlePresetClick('lastMonth')}
                    >
                      Last 30 days
                    </Button>
                  </div>
                </CardBody>
              </Card>
        </Col>
      </Row>
        </ModalBody>
        <ModalFooter className="border-top">
          <Button theme="white" onClick={handleCancelDatePickerModal}>Cancel</Button>
          <Button theme="accent" onClick={handleApplyDateRange}>Apply</Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
}

export default Payments;
